import React, { ReactNode, useMemo } from 'react';
import { Button, ButtonProps } from '@cp/ds/src/components/button';
import { getTariffPerMonthPrice, getTariffPriceWithDiscount, getTariffTermLabel, isContainMonth } from '@cp/entities/tariff';
import { useClientSubscription } from 'src/entities/subscription';
import { Price } from 'src/shared/ui/price';
import { useToggleSubscription } from '../model';

export interface ToggleSubscriptionButtonProps extends ButtonProps {}
export const ToggleSubscriptionButton: React.FC<ToggleSubscriptionButtonProps> = (props) => {
  const { data: subscription } = useClientSubscription();
  const [toggle, { isProcessing }] = useToggleSubscription();
  const text: ReactNode = useMemo(() => {
    if (!subscription) {
      return 'Оформить';
    } else if (subscription.renewal) {
      return 'Отменить подписку';
    } else if (subscription.tariff?.deletedAt) {
      return 'Оформить';
    } else if (subscription.tariff) {
      return (
        <>
          Возобновить за&nbsp;
          {isContainMonth(subscription.tariff) ? (
            <>
              <Price value={getTariffPerMonthPrice(subscription.tariff)} />
              &nbsp;в&nbsp;месяц
            </>
          ) : (
            <>
              <Price value={getTariffPriceWithDiscount(subscription.tariff)} />
              &nbsp;в&nbsp;{getTariffTermLabel(subscription.tariff)}
            </>
          )}
        </>
      );
    } else {
      return 'Оформить';
    }
  }, [subscription]);

  return (
    <Button disabled={isProcessing} onClick={toggle} variant={subscription?.renewal ? 'secondary' : 'primary'} {...props}>
      {text}
    </Button>
  );
};
ToggleSubscriptionButton.displayName = 'ToggleSubscriptionButton';
